// import { initializeApp } from 'firebase/app';
import { getDatabase, ref, push, onValue, set } from "firebase/database";
import Header from "../Header";
import React from "react";
import reactDom from "react-dom";
import {Rsignup} from "./Rsignup";
import Home from "../home/Home";
import "./login.css";
import emailjs from "@emailjs/browser";
import Cdashboard from "../dashboard/Cdashboard";
import Dashboard from "../dashboard/dashboard";
import { CSSTransition } from "react-transition-group";

//! please use comments to show me exactly where email js should be implemented

//! too much use of querySelectors, you can use a normal HTML form tag and call the onSubmit event to capture form inputs for some logic


//no need for emailJs in login page we need emailJS on submission of guarantors form, househelp request form and fulltime request.

function insertdata_dashboard(data) {
  sessionStorage.setItem("name", data.firstname);
  sessionStorage.setItem("lastname", data.lastname);
  sessionStorage.setItem("SOO", data.SOO);
  sessionStorage.setItem("age", data.age);
  sessionStorage.setItem("jobtype", data.jobtype);
  sessionStorage.setItem("pnumber", data.pnumber);
  sessionStorage.setItem("email", data.email);
  console.log(data);
  renderDashboard();
}

function insertdata_cdashboard(data) {
  sessionStorage.setItem("cname", data.firstname);
  sessionStorage.setItem("clastname", data.lastname);
  sessionStorage.setItem("cemail", data.email);
  sessionStorage.setItem("age", data.age);
  sessionStorage.setItem("jobtype", data.jobtype);
  sessionStorage.setItem("pnumber", data.pnumber);
  sessionStorage.setItem("cemail", data.email);
  renderCdashboard();
}

const getformdata2 = (e) => {
  var email = document.querySelector("#email").value;
  var password = document.querySelector("#password").value;

  console.log(email, password);

  if (email !== "" && password !== "") {
    document.querySelector("#data").innerHTML = "waiting For Network";
    getDatabasedatausers(email, password);

    document.querySelector("#email").value = "";
    document.querySelector("#password").value = "";
  } else {
    document.querySelector("#data").innerHTML =
      "incorrect username && password";
  }
};

const getformdata2ASignup = (e) => {
  var email = document.querySelector("#email").value;
  var password = document.querySelector("#password").value;
  var names = document.querySelector("#names").value;
  var pnumber = document.querySelector("#pnumber").value;
  function generateSixDigitNumber() {
    // Generate a random number between 0 and 1 (exclusive)
    const randomNumber = Math.random();

    // Multiply by 1000000 to get a number between 0 and 999999.999999
    const scaledNumber = randomNumber * 1000000;

    // Round down to the nearest integer to get a 6-digit number
    const sixDigitNumber = Math.floor(scaledNumber);

    // Return the result
    return sixDigitNumber;
  }
  var Vcode = generateSixDigitNumber();

    emailjs.send("service_nw0wat9","template_7bpss3v",{
      Vcode:Vcode,
      names:names,
      email:email
    },
    "user_lzazs3LcmmQk6woxHIzQJ");

  
  console.log(email, password);
  const db = getDatabase();
  if (names !=="" && email !== "" && password !== "") {
    document.querySelector("#data").innerHTML = "waiting For Network";
    document.querySelector(".code-confirm-div").style.display="block"
    document.querySelector(".ARFORM").style.display="none"
    
    
    // getDatabasedatausers(email, password);
    push(ref(db, "/assistant"), {
      names:names,
      email:email,
      password:password
    }).then(()=>{
      console.log("data stored successfully")
    })
    console.log(email,password,names)
    document.querySelector("#email").value = "";
    document.querySelector("#password").value = "";
  } else {
    document.querySelector("#data").innerHTML =
      "incorrect username && password";
  }
};
const getDatabasedatacustomer = (email, password) => {
  console.log("passed data " + email, password);

  const db = getDatabase();
  const starCountRefcustomers = ref(db, "Fulltime_Request/");

  onValue(starCountRefcustomers, (snapshot) => {
    snapshot.forEach((element) => {
      const data = element.val();

      if (data.email === email && data.cpassword === password) {
        insertdata_cdashboard(data);
        renderCdashboard();
      } else {
        console.log("incorrect password or email.");
        document.querySelector("#data").innerHTML =
          "incorrect password or email.";
        document.querySelector("#data").innerHTML =
          "incorrect password or email.";
      }
    });
  });
};
const getDatabasedatausers = (email, password) => {
  console.log("passed data " + email, password);

  const db = getDatabase();
  const starCountRefusers = ref(db, "users/");

  onValue(starCountRefusers, (snapshot) => {
    snapshot.forEach((element) => {
      const data = element.val();

      if (data.email === email && data.password === password) {
        console.log(data.email, " ", "data matched");
        insertdata_dashboard(data);
      } else {
        getDatabasedatacustomer(email, password);
      }
    });
  });
};

const getDatabasedataAssistant = (email, password) => {
  console.log("passed data " + email, password);

  const db = getDatabase();
  const starCountRefusers = ref(db, "asistance/");

  onValue(starCountRefusers, (snapshot) => {
    snapshot.forEach((element) => {
      const data = element.val();

      if (data.email === email && data.password === password) {
        console.log(data.email, " ", "data matched");
        insertdata_dashboard(data);
      } else {
        getDatabasedatacustomer(email, password);
      }
    });
  });
};

var submit2 = document.querySelector("#sumbit_button_l");

class ALogin extends React.Component {
  componentDidMount() {
    var span = document.querySelector(".spnn").addEventListener("click", () => {
      // renderSignup();
      window.location.href="asignup"
    });

    var logologo = document.querySelector("#logo-logo");
    logologo.style.display = "none";
  }

  render() {
    return (
      <div className="div">
        <CSSTransition
          timeout={500}
          transitionname="carousel"
          transitionappear="true"
        >
          <div>
            <h1 style={{ textAlign: "center" }}>Login</h1>
            <form name="Login">
         
              <p>Email</p>
              <input type="email" id="email" required></input>

              <p>Password</p>
              <input type="password" id="password" required></input>

              <input
                type="submit"
                value="Submit"
                id="submit_button_l"
                onClick={getformdata2}
                style={{}}
              ></input>
              <div id="data" style={{ color: "red" }}>
                {" "}
              </div>

              <div>
                <span className="spnn">
                  Don't have an Account , {" " + "   " + " "}{" "}
                  <span style={{ color: "green" }}> Signup now</span>
                </span>
              </div>
            </form>
          </div>
        </CSSTransition>
      </div>
    );
  }
}

class ASignup extends React.Component {
  componentDidMount() {

    document.querySelector(".code-confirm-div").style.display="none"
    var span = document.querySelector(".spnn").addEventListener("click", () => {
      // renderSignup();
      window.location.href="Alogin"
    });

    var logologo = document.querySelector("#logo-logo");
    logologo.style.display = "none";
  }

  render() {
    return (
      <div className="div">
        <p style={{color:"black", textAlign:"center",fontFamily:"monospace"}}>register as an Affiliate or login if you alredy have an account</p>

        <CSSTransition
          timeout={500}
          transitionname="carousel"
          transitionappear="true"
        >
          <div style={{fontFamily:"monospace"}}>
            
            <form name="Login">
              <div className="ARFORM" style={{}}>
            <h1 style={{ fontSize:"1.3em", textAlign: "center",fontFamily:"monospace"}}>Registration</h1>

            <p>Names </p>
              <input placeholder="Enter Your Names" type="text" id="names" required></input>

              <p>Email</p>
              <input type="email" id="email" required></input>

              <p>Tel:</p>
              <input type="tel" id="pnumber" required></input>

              <p>Password</p>
              <input type="password" id="password" required></input>

              <input
                type="submit"
                value="Submit"
                id="submit_button_l"
                onClick={getformdata2ASignup}
                style={{}}
              ></input>
              <div id="data" style={{ color: "red" }}>
                {" "}
              </div>

              <div>
                <span className="spnn">
                  Already have an Account , {" " + "   " + " "}{" "}
                  <span style={{ color: "green" }}> Login now</span>
                </span>
              </div>
              </div>

              <div className="code-confirm-div">
          <input type="number"  className="code-confirm-input"></input>
          <br></br>
          <button style={{backgroundColor:"#074707"}} className="code-confirm-btn" onClick={()=>{
            console.log("click")
          }}>confirm code</button>
        </div>
            </form>
          </div>
        </CSSTransition>

       
      </div>
    );
  }
}
function renderSignup() {
  reactDom.render(
    <div>
      <Header />
      <ASignup />
    </div>,
    document.querySelector("#root")
  );
}

function renderDashboard(Props) {
  reactDom.render(
    <React.StrictMode>
      <Header />
      <Dashboard />
    </React.StrictMode>,
    document.querySelector("#root")
  );
}

function renderCdashboard(Props) {
  reactDom.render(
    <React.StrictMode>
      <Header />
      <Cdashboard />
    </React.StrictMode>,
    document.querySelector("#root")
  );
}

export  {ALogin,ASignup};
